<div class="dashboard" *ngIf="currentApp">
  <div class="dashboard-header">
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>
    <div class="divider"></div>
    <lhpe-select
      placeholder="Add Widget"
      [control]="addWidgetControl"
      [options]="filteredWidgets"
      displayValue="name"
      optionValue="code"
    >
    </lhpe-select>
  </div>
  <div class="grid-area">
    <grid-stack (onGridInit)="onGridInit()" (window:resize)="onResize($event)">
      <!-- Once grid is initialized, load widgets -->
      <ng-container *ngIf="gridInitialized">
        <ng-container *ngFor="let widget of widgets">
          <app-generic-widget
            *ngIf="widget.type === 'generic' && permissionService.isWidgetAvailable('generic', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-generic-widget>
          <app-weather-widget
            *ngIf="widget.type === 'weather' && permissionService.isWidgetAvailable('weather', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-weather-widget>

          <app-deliveries-by-category-widget
            *ngIf="widget.type === 'deliveries_by_category' && permissionService.isWidgetAvailable('deliveries_by_category', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-deliveries-by-category-widget>

          <app-installs-widget
            *ngIf="widget.type === 'installs' && permissionService.isWidgetAvailable('installs', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-installs-widget>

          <app-mobile-location-allowed-widget
            *ngIf="widget.type === 'mobile_location_allowed' && permissionService.isWidgetAvailable('mobile_location_allowed', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-mobile-location-allowed-widget>

          <app-region-snapshot-widget
            *ngIf="widget.type === 'regions_snapshot' && permissionService.isWidgetAvailable('regions_snapshot', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-region-snapshot-widget>

          <app-on-property-widget
            *ngIf="widget.type === 'on_property' && permissionService.isWidgetAvailable('on_property', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-on-property-widget>
          <app-delivered-content-widget
            *ngIf="widget.type === 'delivered_content' && permissionService.isWidgetAvailable('delivered_content', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-delivered-content-widget>

          <app-assistant-threads-widget
            *ngIf="widget.type === 'assistant_threads' && permissionService.isWidgetAvailable('assistant_threads', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-assistant-threads-widget>

          <app-assistant-devices-users-widget
            *ngIf="widget.type === 'assistant_devices_users' && permissionService.isWidgetAvailable('assistant_devices_users', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-assistant-devices-users-widget>

          <app-assistant-shares-ratings-feedback-widget
            *ngIf="widget.type === 'assistant_shares_ratings_feedback' && permissionService.isWidgetAvailable('assistant_shares_ratings_feedback', currentAccount)"
            class="widget-component"
            [ngClass]="{ hovering: widget.hovering }"
            [grid]="grid"
            [widget]="widget"
            [filterForm]="filterForm"
            (onWidgetDelete)="deleteWidget(widget)"
            (onWidgetOptionsUpdate)="saveDashboard()"
            (onResizeWidget)="onResizeWidget()"
            (onWidgetHeaderMouseDown)="enableMoveWidgets()"
            (onWidgetHeaderMouseUp)="disableMoveWidgets()"
            (mouseenter)="widget.hovering = true"
            (mouseleave)="widget.hovering = false"
            attr.id="grid-item-{{ widget.code }}"
            attr.code="{{ widget.code }}"
            attr.gs-w="{{ widget.width }}"
            attr.gs-h="{{ widget.height }}"
            attr.gs-x="{{ widget.xPosition }}"
            attr.gs-y="{{ widget.yPosition }}"
          >
          </app-assistant-shares-ratings-feedback-widget>
        </ng-container>
      </ng-container>
    </grid-stack>
  </div>
</div>

<div *ngIf="!currentApp">No App Selected</div>
